import { combineReducers } from "redux";
import restaurant from "./restaurant.reducer";
import animation from "./animation.reducer"
import website from "./website.reducer";
import request from "./request.reducer";
import loader from "./loader.reducer";
import scroll from "./scroll.reducer";
import order from "./order.reducer";
import error from "./error.reducer";
import cart from "./cart.reducer";
import user from "./user.reducer";

export default combineReducers({
  restaurant,
  animation,
  website,
  request,
  loader,
  scroll,
  order,
  error,
  cart,
  user
});
